module.exports = __webpack_public_path__ + "img/Northern Mariana Islands.ac7dd233.svg";